<template>
  <div>
     <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>Basic data</el-breadcrumb-item>
      <el-breadcrumb-item v-if="visible" >Agent Info</el-breadcrumb-item >
      <el-breadcrumb-item>My Agent Plumber</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header  @back="goBack"  content="My Agent Plumber" v-if="visible"></el-page-header>
    <el-divider v-if="visible"></el-divider>
 <!-- 卡片视图区域 -->
 <el-card>
      <collapse @getDataList="search" :button-text="'search'">
        <collapse-item>
           <span class="Agent">Agent:</span> 
          <el-input placeholder="Agent" v-model="queryInfoparams.params.agent" clearable></el-input>
        </collapse-item>
        <collapse-item>
        <span class="PlumberCompany">Plumber Company:</span> 
            <el-input placeholder="companyName" v-model="queryInfoparams.params.company" clearable></el-input>      
        </collapse-item>
        <collapse-item>
         <span class="Name">Name:</span> 
          <el-input placeholder="Name" v-model="queryInfoparams.params.name" clearable></el-input>        
        </collapse-item>
        <collapse-item>
         <span class="Phone">Phone:</span> 
            <el-input placeholder="Phone" v-model="queryInfoparams.params.phone" clearable></el-input>     
        </collapse-item> 
        <collapse-item>
         <span class="email">Email:</span> 
          <el-input placeholder="Email" v-model="queryInfoparams.params.email" clearable></el-input>        
        </collapse-item>
   </collapse>
    <el-row type="flex" justify="end">
               <el-col class="searchBtns" :span="6">
                <el-button-group>
                 <el-button plain size="small"  icon="el-icon-share" @click="exportData"  v-hasPermission="['engineer:export']" >Export</el-button>
                 <el-button plain size="small"  icon="el-icon-check" @click="setIsSupper" v-hasPermission="['engineer:issuper']" >issuper</el-button> 
                 <el-button plain size="small"  icon="el-icon-close" @click="setIsNotSupper" v-hasPermission="['engineer:issuper']" >notsuper</el-button> 
                </el-button-group>
               </el-col>
   </el-row> 
   <el-table :data="dataList" border stripe @selection-change="handleSelectionChange">
   <el-table-column type="selection" width="55"></el-table-column>
   <el-table-column type="index" label="No."></el-table-column>
   <el-table-column label="Agent" sortable prop="agencyName" width="160px"></el-table-column>
   <el-table-column label="Plumber company" sortable prop="companyName"></el-table-column>
   <el-table-column label="email" sortable prop="email"></el-table-column>
   <el-table-column label="First Name" sortable prop="firstName"></el-table-column>
   <el-table-column label="Last Name" sortable prop="lastName"></el-table-column>
   <el-table-column label="Phone number" sortable prop="mobileNumber"></el-table-column>
   <el-table-column label="Area" sortable prop="detailAddress" width="160px"></el-table-column>
   <el-table-column label="Status" sortable prop="status">
      <template slot-scope="scope">
            <el-tag v-if="scope.row.status==='0'" >Enabled</el-tag>
            <el-tag v-else-if="scope.row.status==='1'" >Disabled</el-tag>
      </template>
   </el-table-column>
   <el-table-column label="Source" sortable prop="source" width="160px"></el-table-column>
   <el-table-column label="isSuper" sortable prop="isSupper" width="120px">
      <template slot-scope="scope">
            <el-tag v-if="scope.row.isSupper==='Y'" >Yes</el-tag>
            <el-tag v-else-if="scope.row.isSupper==='N'" >No</el-tag>
      </template>
   </el-table-column>
   <el-table-column label="Tests done last week" sortable prop="testingWeek"></el-table-column>
   <el-table-column label="Tests done last month" sortable prop="testingMonth"></el-table-column>
  </el-table>
    <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
 </el-card> 
   
 </div>
</template>

<script>
import db from '@/services/localstorage';
import Collapse from '@/components/collapse/Collapse'
import CollapseItem from '@/components/collapse/CollapseItem'
export default {
    components:{Collapse,CollapseItem},
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last three month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        options: [
          {
          value: '',
          label: ''
        },{
          value: '9',
          label: 'all'
        }, {
          value: '1',
          label: 'used'
        }, {
          value: '0',
          label: 'unused'
        }],
        addressOptions: [
          {
          value: '',
          label: ''
        }],
        userId:'',
        value: '',
        queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
        },
        dataList: [],
        multipleSelection: [],
        addForm: {
        agencyName:'',
        email:'',
        companyName:'',
        loginAccount: '',
        firstName:'',
        mobileNumber:'',
        lastName:'',
        postCode:'',
        address:'',
        userId:'',
        source:'',
        companyId:'',
        },
        userId:'',
        companyId:'',
        // 添加表单的验证规则对象
        addFormRules: {},
        total: 0,
        agencyId:this.$route.query.agencyId,
        //是否显示header头
        visible:this.$route.query.visible,
        // 控制添加 对话框的显示与隐藏
        addDialogVisible: false,
        // 控制修改用户对话框的显示与隐藏
        editDialogVisible: false,
        editEmailVisible: false,
        addFormRules: {}
      }
    },

    created(){
      var user=db.get("user");
      this.userId=user.userId;
      this.addForm.userType=user.userType;
      this.companyId=user.companyId;
      this.queryInfoparams.params.userType=user.userType;
      this.queryInfoparams.params.agencyId=this.agencyId;
      this.userId=user.userId;

      this.search()
    },
    methods: {

    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log('multipleSelection', this.multipleSelection)
    },
     setIsSupper() {

      if (this.multipleSelection.length == 1){
         this.multipleSelection.forEach((row) => {
          this.$get(`engineer/isSuper/${row.id}/Y`).then(({ data: res }) => {
          
          if (res.msg !== 'successfully') {
            return this.$message.error('Update unsuccessfully')
          }
          // 刷新数据列表
          this.search()
          this.$message.success('Update successfully')
           })
         })
      
      }else{
         return this.$message.error('Please select one')
      }

    },
      setIsNotSupper() {

       if (this.multipleSelection.length == 1){
         this.multipleSelection.forEach((row) => {
       this.$get(`engineer/isSuper/${row.id}/N`).then(({ data: res }) => {
          
          if (res.msg !== 'successfully') {
            return this.$message.error('Update unsuccessfully')
          } 
          this.search()
          // 提示修改成功
          this.$message.success('Update successfully')
        })
         })
        }else{
         return this.$message.error('Please select one')
      }
    },

    goBack() {
      this.$router.back()
    },
    search(){
        this.queryInfoparams.current=0
         this.getDataList()
    },
        // 获取 查询数据列表
    async getDataList() {      
      this.$post('engineer/pageQuery', this.queryInfoparams).then(
          ({ data: res }) => {
            this.dataList = res.records
            this.total = res.total
          }
        )
    },
        // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },

    // 点击按钮 添加
    async exportData() {
       console.log("queryInfoparams:"+this.queryInfoparams.params.userType)
     // addForm.userId=db.get("userId")
     let res = this.$export("engineer/export",JSON.stringify(this.queryInfoparams),"plumber_information")
    },
 
     async reset() {
       this.queryInfoparams.params.agent='';
       this.queryInfoparams.params.company='';
       this.queryInfoparams.params.name='';
       this.queryInfoparams.params.phone='';
       this.queryInfoparams.params.email='';
    },
   }
  }

</script>

<style lang="less" scoped>
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.collapseBtn {
  height: 40px;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}

#el-collapse-head-4510{
  height: auto;
}
.el-col{
  display: flex;
}
.el-date-editor{
   height: auto;
   width:auto;
}
.demonstration1{
  height: auto;
  width:25%;
}
.el-button{
     height: auto;
     width:auto;
}
.left{
  width:auto;
}
#el-input__inner{
  width:200px;
}
</style>